import { render } from "./gsggDetail.vue?vue&type=template&id=928bc640&scoped=true&ts=true"
import script from "./gsggDetail.vue?vue&type=script&lang=ts"
export * from "./gsggDetail.vue?vue&type=script&lang=ts"

import "./gsggDetail.vue?vue&type=style&index=0&id=928bc640&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928bc640"]])

export default __exports__